import ShareService from '@/services/share.service'

export default {
  namespaced: true,
  state: {
    form: null,
    cotacao: null,
    contato: null,
    filtros: {
      tipo_plano: null,
      contratacao: null,
      acomodacao: null,
      regras_aceitacao: null,
      coparticipacao: null,
      compulsorio: null,
      cidade: null,
      credenciado: null,
      entidade_profissao: null,
      faixas: [],
      mei: null
    },
    aux: null,
    loading: false,
    error: null
  },
  mutations: {
    setLoading: (state, loading) => state.loading = loading,
    setError: (state, error) => state.error = error,
    setForm: (state, form) => state.form = form,
    setCotacao: (state, cotacao) => state.cotacao = cotacao,
    setContato: (state, contato) => state.contato = contato,
    setFiltros: (state, filtros) => state.filtros = filtros,
    setAux: (state, aux) => state.aux = aux,
  },
  actions: {
    ['updateForm']({commit}, form) {
      commit('setForm', form)
    },
    ['updateFiltros']({ commit }, filtros) {
      commit('setFiltros', filtros)
    },
    ['updateAux']({ commit }, aux) {
      commit('setAux', aux)
    },
    async ['enviarCotacao']({ commit },
      cotacao
    ) {
      try {
        commit('setLoading', true)
        const data = await ShareService.enviarCotacao(cotacao)
        commit('setForm', null)
        commit('setCotacao', data)
      } catch (error) {
        commit('setError', error)
      } finally {
        commit('setLoading', false)
      }
    },
    async ['atualizarCotacao'](
      { commit },
      cotacao
    ) {
      try {
        commit('setLoading', true)
        const data = await ShareService.atualizarCotacao(cotacao)
        commit('setForm', null)
        commit('setCotacao', data)
      } catch (error) {
        commit('setError', error)
      } finally {
        commit('setLoading', false)
      }
    },
    async ['associarLead'](
      { commit },
      cotacao
    ) {
      try {
        const data = await ShareService.associarLead(cotacao)
      } catch (error) {
        commit('setError', error)
      } finally {
      }
    },
    async ['cotacao']({ commit }, id) {
      try {
        commit('setLoading', true)
        const data = await ShareService.cotacao(id)
        commit('setCotacao', data)
      } catch (error) {
        commit('setError', error)
      } finally {
        commit('setLoading', false)
      }
    },
    async ['email']({ commit }, cotacao) {
      try {
        commit('setLoading', true)
        const data = await ShareService.email(cotacao)
        commit('setForm', null)
      } catch (error) {
        commit('setError', error)
      } finally {
        commit('setLoading', false)
      }
    },
    async ['contato'](
      { commit },
      {
        codigo,
        nome,
        email,
        celular,
        telefone,
        contato_tipo,
        contato_data,
        contato_horario,
        mensagem,
        informacao
      }
    ) {
      try {
        commit('setLoading', true)
        const data = await ShareService.contato(
          codigo,
          nome,
          email,
          celular,
          telefone,
          contato_tipo,
          contato_data,
          contato_horario,
          mensagem,
          informacao
        )
        commit('setContato', data)
      } catch (error) {
        commit('setError', error)
      } finally {
        commit('setLoading', false)
      }
    }
  },
  getters: {
    getLoading: state => state.loading,
    getError: state => state.error,
    getForm: (state) => state.form,
    getCotacao: (state) => state.cotacao,
    getContato: (state) => state.contato,
    getFiltros: (state) => state.filtros,
    getAux: (state) => state.aux,
  }
}
